import { render } from "./EC.vue?vue&type=template&id=1f2ef90b"
import script from "./EC.vue?vue&type=script&lang=js"
export * from "./EC.vue?vue&type=script&lang=js"

import "./EC.vue?vue&type=style&index=0&id=1f2ef90b&lang=css"

import exportComponent from "/media/alvian/New Volume14/project/vue js/sfa-nepal-web-report/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__